import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  FaqComponent,
  FaqItem,
} from '../../../shared/components/faq/faq.component';

/** The `faq` outlet of an info page; its questions come from route data. */
@Component({
  selector: 'app-info-faq',
  imports: [FaqComponent],
  templateUrl: './info-faq.component.html',
  styleUrls: ['./info-faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoFaqComponent {
  public readonly faqItems: FaqItem[] =
    inject(ActivatedRoute).snapshot.data['faq'] ?? [];
}
